/** QuickRouter — Classe d'un net d'après son nom (module à part : partagé par ops et le schéma). */

/** Nom évocateur d'une alimentation → classe power. */
export function guessKind(name) {
  return /^(gnd|agnd|pgnd|vcc|vdd|vin|vbus|vbat|v?\+?\d+v\d*|\d+v\d*|3v3|5v|12v|24v|vout|pwr)/i.test(name) ? 'power' : 'signal';
}
